<!-- ============================================================== -->
<!-- Bread crumb and right sidebar toggle -->
<!-- ============================================================== -->
<div class="page-breadcrumb" >
  <div class="row">
      <div class="col-7 align-self-center">
          <div class="d-flex align-items-center">
              <nav aria-label="breadcrumb">
                  <ol class="breadcrumb">
                    
                      <li class="breadcrumb-item active" aria-current="page">Dashboard</li>
                  </ol>
              </nav>
          </div>
          <h4 class="page-title">Dashboard</h4>
      </div>
      
  </div>
</div>

<!-- ============================================================== -->
<!-- End Bread crumb and right sidebar toggle -->
<!-- ============================================================== -->
<!-- ============================================================== -->
<!-- Container fluid  -->
<!-- ============================================================== -->
<section class="content">
      <!-- Small boxes (Stat box) -->
      <div class="row">
        <div class="col-lg-3 col-xs-6">
          <!-- small box -->
          <div class="small-box bg-aqua" style="height: 115px;">
            <div class="inner">
              <h3>{{usersCount.count}}<sup style="font-size: 20px"></sup></h3>

              <p>Total Users</p>
            </div>
            <div class="icon">
              <!--<i class="ion ion-bag"></i>-->
              <i  aria-hidden="true" class="fa fa-user" style="margin-top: 15px;"></i>
          </div>
          </div>
        </div>
        <!-- ./col -->
        <div class="col-lg-3 col-xs-6">
          <!-- small box -->
          <div class="small-box bg-green"  style="height: 115px;">
            <div class="inner">
              <h3>{{accountsCount.count}}<sup style="font-size: 20px"></sup></h3>

              <p>Total Accounts</p>
            </div>
            <div class="icon">
              <!--<i class="ion ion-stats-bars"></i>-->
              <i  aria-hidden="true" class="fa fa-address-card"  style="margin-top: 15px;"></i>

            </div>
          </div>
        </div>
        <!-- ./col -->
        <div class="col-lg-3 col-xs-6">
          <!-- small box -->
          <div class="small-box bg-yellow"  style="height: 115px;">
            <div class="inner">
              <h3>{{productsCount.count}}</h3>

              <p>Total Products</p>
            </div>
            <div class="icon">
              <!--<i class="ion ion-person-add"></i>-->
              <i class="fa fa-cubes" aria-hidden="true"  style="margin-top: 15px;"></i>

            </div>
          </div>
        </div>
        <!-- ./col -->
        <div class="col-lg-3 col-xs-6">
          <!-- small box -->
          <div class="small-box bg-red"  style="height: 115px;">
            <div class="inner">
              <h3>{{vendorsCount.count}}</h3>

              <p>Total Vendors</p>
            </div>
            <div class="icon">
              <i class="fa fa-handshake" aria-hidden="true"  style="margin-top: 15px;"></i>
            </div>
          </div>
        </div>
        <!-- ./col -->



       
      </div>
      <!-- /.row -->
      <!-- Main row -->
      
      <!-- /.row (main row) -->

    </section>
<!-- ============================================================== -->
<!-- End Container fluid  -->
<!-- ============================================================== -->
<!-- ============================================================== -->
<!-- End Container fluid  -->
<!-- ============================================================== -->